<template>
	<div class="openedList-body">
		<div class="order-menu">
			<span>
				<i class="el-icon-back" @click="goBack"></i>
				极速订2.0已开通商户
			</span>
		</div>
		<div class="search-box">
			<div class="search-div">
				<span>条件筛选：</span>
				<el-select v-model="type" class="select-input" size='small' style="margin: 0 10px">
					<el-option :value="0" label="企业名称"></el-option>
					<el-option :value="1" label="注册码"></el-option>
					<el-option :value="2" label="门店号（C号）"></el-option>
					<el-option :value="3" label="集团号（G号）"></el-option>
				</el-select>
				<el-input
					v-model="keyWord"
					size="small"
					@keyup.enter.native="search">
				</el-input>
			</div>
			<div class="search-div">
				<span>结算方式:</span>
				<el-select v-model="consumetype" class="select-input" size='small'>
					<el-option :value="0" label="全部"></el-option>
					<el-option :value="1" label="包年"></el-option>
				</el-select>
			</div>
			<div class="search-div">
				<span>开通时间:</span>
				<el-date-picker
					v-model="dateValue"
					:clearable="false"
					:unlink-panels='true'
					class="time-input"
					size="small"
					type="daterange"
					range-separator="至"
					start-placeholder="开始日期"
					end-placeholder="结束日期"
					format='yyyy-MM-dd'
					value-format='yyyy-MM-dd'>
				</el-date-picker>
			</div>
			<div class="search-div">
				<el-button size="small" type="primary" class="btn fx-btn" @click="search">查询</el-button>
				<el-button size="small" type="primary" class="btn fx-btn" @click="exportExcel">导出</el-button>
			</div>
		</div>
		<div class="main-table-box">
			<el-table
			:stripe='true'
			size='mini'
			class="grid-content"
			:data="tableData"
			:height="tableHeight"
			border
			ref="table">
				<el-table-column
					prop="name"
					key="name"
					label="企业名称"
					align="center"
					min-width="200">
					<template slot-scope='scope'>
						<div>{{scope.row.orgname}}</div>
						<div>{{scope.row.storecode}}</div>
					</template>
				</el-table-column>
				<el-table-column
					label="注册码"
					align="center"
					min-width="100">
					<template slot-scope='scope'>
						<div>{{scope.row.syscode}}</div>
					</template>
				</el-table-column>
				<el-table-column
					label="开通/到期时间"
					align="center"
					min-width="350">
					<template slot-scope='scope'>
						<div>{{scope.row.opendate}}-{{scope.row.expiretiondate}}</div>
					</template>
				</el-table-column>
				<el-table-column
					prop="count"
					key="count"
					label="终端数"
					align="center"
					min-width="80">
				</el-table-column>
				<el-table-column
					prop="groupname"
					label="所属集团"
					align="center"
					min-width="150">
					<template slot-scope='scope'>
						<div>{{scope.row.groupname}}</div>
						<div>{{scope.row.groupcode}}</div>
					</template>
				</el-table-column>
				<el-table-column
					prop="consumetype"
					label="结算方式"
					align="center"
					min-width="150">
				</el-table-column>
				<el-table-column
					label="版本"
					prop="openenviroment"
					align="center"
					min-width="150">
				</el-table-column>
				<el-table-column
					label="标签"
					align="center"
					prop="type"
					min-width="150">
				</el-table-column>
				<el-table-column
					label="默认账户"
					prop="tel"
					align="center"
					min-width="150">
				</el-table-column>
				<el-table-column
					prop="password"
					label="默认密码"
					align="center"
					min-width="150">
				</el-table-column>
				<el-table-column
					prop="servicername"
					label="归属"
					align="center"
					min-width="150">
				</el-table-column>
			</el-table>
		</div>
		<div style="padding-top: 10px;background-color: #fff">
			<el-pagination
				@size-change="handleSizeChange"
				@current-change="handleCurrentChange"
				:current-page="page.number"
				:page-sizes="[20, 40, 60, 100, 300]"
				:page-size="page.size"
				layout="total, sizes, prev, pager, next, jumper"
				:total="total">
			</el-pagination>
		</div>
    </div>
</template>
<script>
export default {
	name: 'openedList',
	components: {
	},
	data () {
		return {
			consumetype: 0,
			type: 0,
			keyWord: '',
			dateValue: [],
			tableData: [],
			servicerCode: null,
			tableHeight: '100%',
			total: 0,
			page: {
				number: 1,
				size: 20
			}
		}
	},
	created () {
		let servicerCode = this.$route.query.servicerCode
		if (servicerCode !== 'null') {
			this.servicerCode = servicerCode
		}
		this.tableReload()
	},
	methods: {
		goBack () {
			let params = {
				type: 'close'
			}
			window.parent.postMessage(params, '*')
		},
		exportExcel () {
			const req = new XMLHttpRequest()
			let _this = this
			req.open('POST', `${this.$fxBaseApi.nsExportUrl}/organ/exportExcel`, true)
			req.responseType = 'blob'
			req.setRequestHeader('Content-Type', 'application/json')
			req.setRequestHeader('pname', 'bc2ff5388144d30e137b28acafd39795')
			req.setRequestHeader('shiroSession', window.sessionStorage.getItem('shiroSession'))
			req.onload = function () {
				const data = req.response
				const blob = new Blob([data])
				const blobUrl = window.URL.createObjectURL(blob)
				_this.download(blobUrl)
			}
			let storecode = ''
			let groupcode = ''
			let orgname = ''
			let syscode = ''
			switch (this.type) {
			case 0:
				orgname = this.keyWord
				break
			case 1:
				syscode = this.keyWord
				break
			case 2:
				storecode = this.keyWord
				break
			case 3:
				groupcode = this.keyWord
				break
			}
			let params = {
				storecode: storecode,
				servicercode: this.servicerCode,
				groupcode: groupcode,
				orgname: orgname,
				syscode: syscode,
				consumetype: this.consumetype
			}
			if (this.dateValue && this.dateValue.length > 0) {
				params.startDate = this.dateValue[0]
				params.endDate = this.dateValue[1]
			}
			req.send(JSON.stringify(params))
		},
		download (blobUrl, num) {
			const a = document.createElement('a')
			a.style.display = 'none'
			let name = '已开通配置列表.xls'
			a.download = name
			a.href = blobUrl
			a.click()
		},
		search () {
			this.page = {
				number: 1,
				size: 20
			}
			this.tableReload()
		},
		tableReload () {
			let storecode = ''
			let groupcode = ''
			let orgname = ''
			let syscode = ''
			switch (this.type) {
			case 0:
				orgname = this.keyWord
				break
			case 1:
				syscode = this.keyWord
				break
			case 2:
				storecode = this.keyWord
				break
			case 3:
				groupcode = this.keyWord
				break
			}
			let params = {
				servicercode: this.servicerCode,
				pages: this.page.number,
				storecode: storecode,
				groupcode: groupcode,
				orgname: orgname,
				syscode: syscode,
				length: this.page.size,
				consumetype: this.consumetype
			}
			if (this.dateValue && this.dateValue.length > 0) {
				params.startDate = this.dateValue[0]
				params.endDate = this.dateValue[1]
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.snvUrl}account/open/organ/list`,
				data: params
			}).then(res => {
				this.tableData = res.data.list
				this.total = res.data.count
			})
		},
		handleSizeChange (val) {
			this.page.size = val
			this.tableReload()
		},
		handleCurrentChange (val) {
			this.page.number = val
			this.tableReload()
		}
	}
}
</script>
<style lang="stylus" scoped>
.openedList-body{
	box-sizing: border-box;
	width: 100%;
	height: calc(100% - 60px);
	overflow: hidden
	display: flex;
	flex-direction: column
}
.order-menu {
	height: 50px
	line-height: 50px
	text-align: left
	background-color: #fff
	font-size: 15px
	box-sizing: border-box
	margin-bottom: 10px
	span {
		display: inline-block;
		line-height: 50px;
		padding-right: 10px;
		i {
			border-radius: 50%;
			cursor: pointer;
			background: #9da6af;
			padding: 3px;
		}
		.el-icon-back:before {
			content: "\E6EA";
			color: #fff;
			font-weight: bold;
		}
	}
}
.search-box{
	display: flex;
	padding-top: 10px;
	line-height: 40px;
	flex-wrap: wrap;
	flex-direction: row;
	align-items: center;
	background-color: #fff
}
.search-div{
	display: flex;
	flex-direction: row
	align-items: center
	justify-content: center
	margin-bottom: 10px
	span{
		display: block
		min-width: 80px;
	}
}
.select-input{
	min-width: 120px;
	width: 120px
}
.main-table-box{
	flex: 1
	background-color: #fff
}
</style>
<style lang="stylus">
</style>
